import script from "./AddBonus.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBonus.vue?vue&type=script&setup=true&lang=js"

import "./AddBonus.vue?vue&type=style&index=0&id=254a67f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-254a67f8"]])

export default __exports__